import type { AnyAction, Reducer } from 'redux';

import type { SuiteHeaderThemeAction } from '../../domains/suiteHeaderTheme/actions.types';

import type { SuiteHeaderTheme } from './types';

export type { SuiteHeaderThemeAction };

const initialState: SuiteHeaderTheme = {
  isDefault: false,
};

const reducer: Reducer<SuiteHeaderTheme, SuiteHeaderThemeAction | AnyAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SUITE_HEADER_THEME.UPDATED':
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
